import type {CSSProperties, ReactElement} from 'react';
import React from 'react';
import './tooltip.scss';
import {getClassesForPosition} from '@Components/tooltip/tooltip-helper';

/**
 * @author Ahmed Ateeq <ahmedateeq@250mils.com>
 */

interface ToolTipProps {
  id: string;
  className?: string;
  position?: TOOLTIP_POSITION;
  text: ReactElement<any>;
  type?: TOOLTIP_TYPE;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  style?: CSSProperties;
  hasRoundedArrow?: boolean;
  ref?: React.RefObject<HTMLDivElement | null>;
}

export enum TOOLTIP_POSITION {
  TOP_MIDDLE = 'TOP_MIDDLE',
  TOP_RIGHT = 'TOP_RIGHT',
  TOP_LEFT = 'TOP_LEFT',
  BOTTOM_MIDDLE = 'BOTTOM_MIDDLE',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  LEFT_MIDDLE = 'LEFT_MIDDLE',
  RIGHT_MIDDLE = 'RIGHT_MIDDLE',
}

export enum TOOLTIP_TYPE {
  DEFAULT = 'DEFAULT',
  MODERN = 'MODERN',
  DARK = 'DARK',
  ERROR = 'ERROR',
}

export function Tooltip({
  className = '',
  position = TOOLTIP_POSITION.BOTTOM_MIDDLE,
  type = TOOLTIP_TYPE.DEFAULT,
  onMouseEnter = $.noop,
  onMouseLeave = $.noop,
  style = {},
  hasRoundedArrow = true,
  ...props
}: ToolTipProps): ReactElement<any> {
  const getClassesForToolTipType = (): string => {
    switch (type) {
      case TOOLTIP_TYPE.MODERN:
        return '-modern';
      case TOOLTIP_TYPE.DARK:
        return '-darker';
      case TOOLTIP_TYPE.ERROR:
        return '-error-tooltip';
      case TOOLTIP_TYPE.DEFAULT:
        return '';
    }
  };

  return (
    <div
      style={style}
      ref={props.ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`tooltip ${hasRoundedArrow ? '_rounded-arrow' : ''} ${getClassesForToolTipType()} ${getClassesForPosition(position)} ${className}`}
    >
      {props.text}
    </div>
  );
}
